function SvgComponent(props: any) {

    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <path
            d="M12 21a9 9 0 100-18 9 9 0 000 18z"
            stroke={props.isSelected ? "#5627FF" : "#000"}
            strokeWidth={1.2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.7 15.6l-2.173-2.172A1.8 1.8 0 0112 12.155V6.6"
            stroke={props.isSelected ? "#5627FF" : "#000"}
            strokeWidth={1.2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
    )
}
  
  export default SvgComponent